import { render, staticRenderFns } from "./pay-dialog.vue?vue&type=template&id=ed5e687c&scoped=true"
import script from "./pay-dialog.vue?vue&type=script&lang=js"
export * from "./pay-dialog.vue?vue&type=script&lang=js"
import style0 from "./pay-dialog.vue?vue&type=style&index=0&id=ed5e687c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5e687c",
  null
  
)

export default component.exports